import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, Instagram, Facebook } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-dark text-cream pt-24 pb-12 relative overflow-hidden">
      {/* Decorative element */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-forest via-gold to-forest"></div>
      
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-forest rounded-full flex items-center justify-center">
                <Leaf className="w-5 h-5 text-cream" />
              </div>
              <span className="font-playfair text-2xl font-bold">FarmBox</span>
            </Link>
            <p className="text-cream/70 font-manrope leading-relaxed mb-6">
              Fresh, local farm boxes delivered across the White Mountains. Support local farms. Eat better. Live fresher.
            </p>
            <div className="flex gap-4 mb-6">
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-forest transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-forest transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <div className="space-y-2">
              <a href="mailto:farmboxadmin@gmail.com" className="flex items-center gap-2 text-cream/70 hover:text-gold transition-colors font-manrope text-sm" data-testid="footer-email">
                <Mail className="w-4 h-4" /> farmboxadmin@gmail.com
              </a>
              <a href="tel:+12074133262" className="flex items-center gap-2 text-cream/70 hover:text-gold transition-colors font-manrope text-sm" data-testid="footer-phone">
                <Phone className="w-4 h-4" /> (207) 413-3262
              </a>
            </div>
          </div>

          {/* Customers */}
          <div>
            <h4 className="font-playfair text-lg font-bold mb-6">Customers</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-cream/70 hover:text-gold transition-colors font-manrope">Shop This Week</Link></li>
              <li><Link to="/shop" className="text-cream/70 hover:text-gold transition-colors font-manrope">Subscriptions</Link></li>
              <li><Link to="/delivery" className="text-cream/70 hover:text-gold transition-colors font-manrope">Delivery Area</Link></li>
              <li><Link to="/login" className="text-cream/70 hover:text-gold transition-colors font-manrope">Customer Login</Link></li>
            </ul>
          </div>

          {/* Farms & Producers */}
          <div>
            <h4 className="font-playfair text-lg font-bold mb-6">Farms &amp; Producers</h4>
            <ul className="space-y-3">
              <li><Link to="/for-farms" className="text-cream/70 hover:text-gold transition-colors font-manrope">Partner With FarmBox</Link></li>
              <li><Link to="/farm/apply" className="text-cream/70 hover:text-gold transition-colors font-manrope">Apply to Join</Link></li>
              <li><Link to="/farm/login" className="text-cream/70 hover:text-gold transition-colors font-manrope">Farm Partner Login</Link></li>
              <li><Link to="/partner-farms" className="text-cream/70 hover:text-gold transition-colors font-manrope">Meet Our Partners</Link></li>
            </ul>
          </div>

          {/* FarmBox */}
          <div>
            <h4 className="font-playfair text-lg font-bold mb-6">FarmBox</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-cream/70 hover:text-gold transition-colors font-manrope">About</Link></li>
              <li><Link to="/partner-farms" className="text-cream/70 hover:text-gold transition-colors font-manrope">Our Farms</Link></li>
              <li><Link to="/faq" className="text-cream/70 hover:text-gold transition-colors font-manrope">FAQ</Link></li>
              <li><Link to="/faq" className="text-cream/70 hover:text-gold transition-colors font-manrope">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/50 text-sm font-manrope">
            © 2026 FarmBox. All rights reserved.
          </p>
          <p className="text-cream/50 text-sm font-manrope">
            Made with love in the White Mountains
          </p>
        </div>
      </div>
    </footer>
  );
}
